var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("查看"),
      visible: _vm.dialogVisible,
      footer: null,
      width: 620
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    ref: "from",
    attrs: {
      model: _vm.from,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "appUrl",
      label: _vm.$t("应用图标")
    }
  }, [_vm.imageUrl ? _c("img", {
    staticStyle: {
      width: "104px",
      height: "104px"
    },
    attrs: {
      src: _vm.imageUrl,
      alt: "avatar"
    }
  }) : _vm._e()]), _c("a-form-model-item", {
    attrs: {
      prop: "name",
      label: _vm.$t("应用名称")
    }
  }, [_c("a-input", {
    attrs: {
      readOnly: true
    },
    model: {
      value: _vm.from.name,
      callback: function ($$v) {
        _vm.$set(_vm.from, "name", $$v);
      },
      expression: "from.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("应用类型"),
      prop: "type"
    }
  }, [_c("a-input", {
    attrs: {
      value: _vm.from.type == 1 ? "app" : _vm.from.type == 2 ? "h5" : _vm.from.type == 3 ? "pc" : _vm.$t("小程序"),
      readOnly: true
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "appid",
      label: _vm.$t("appId")
    }
  }, [_c("a-input", {
    attrs: {
      readOnly: true
    },
    model: {
      value: _vm.from.appid,
      callback: function ($$v) {
        _vm.$set(_vm.from, "appid", $$v);
      },
      expression: "from.appid"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("牌照所属")
    }
  }, [_c("a-input", {
    attrs: {
      readOnly: true
    },
    model: {
      value: _vm.from.customerName,
      callback: function ($$v) {
        _vm.$set(_vm.from, "customerName", $$v);
      },
      expression: "from.customerName"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "introduce",
      label: _vm.$t("应用介绍"),
      hasFeedback: ""
    }
  }, [_c("a-textarea", {
    attrs: {
      rows: 4,
      readOnly: true
    },
    model: {
      value: _vm.from.introduce,
      callback: function ($$v) {
        _vm.$set(_vm.from, "introduce", $$v);
      },
      expression: "from.introduce"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("关联出单渠道")
    }
  }, [_c("a-input", {
    attrs: {
      readOnly: true
    },
    model: {
      value: _vm.from.customerNames,
      callback: function ($$v) {
        _vm.$set(_vm.from, "customerNames", $$v);
      },
      expression: "from.customerNames"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };